import { useState } from 'react'

import { TogglerCheckbox } from '@factorialco/deprecated-design-system'

import { TogglerField } from 'modules/marketplace/hooks/integrations/formQuestions/useGetMarketplaceSettings'

interface TogglerQuestionProps {
  togglerQuestion: TogglerField
  currentValue?: boolean
  onChange: (value: boolean) => void
}

export const TogglerQuestion = ({
  currentValue,
  togglerQuestion: { label, disabled, defaultValue, information },
  onChange,
}: TogglerQuestionProps) => {
  const [value, setValue] = useState((currentValue || defaultValue) ?? false)

  const handleChange = (change: boolean) => {
    setValue(change)
    onChange(change)
  }

  return (
    <TogglerCheckbox
      label={label}
      disabled={disabled}
      informationIcon="info-circle-line"
      value={value}
      information={information}
      onChange={(change) => handleChange(change)}
    />
  )
}
